var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.286 0.713928H0.713867V39.2861H39.286V0.713928Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3514 32.8812V23.0495C31.3514 22.2164 31.1873 21.3915 30.8685 20.6219C30.5497 19.8522 30.0824 19.1529 29.4933 18.5638C28.9043 17.9747 28.2049 17.5075 27.4353 17.1887C26.6656 16.8699 25.8407 16.7058 25.0076 16.7058C24.1746 16.7058 23.3497 16.8699 22.58 17.1887C21.8104 17.5075 21.111 17.9747 20.522 18.5638C19.9329 19.1529 19.4656 19.8522 19.1468 20.6219C18.828 21.3915 18.6639 22.2164 18.6639 23.0495V32.8812H21.8256V23.0495C21.8256 22.2056 22.1609 21.3962 22.7576 20.7994C23.3544 20.2027 24.1637 19.8674 25.0076 19.8674C25.8516 19.8674 26.6609 20.2027 27.2577 20.7994C27.8544 21.3962 28.1897 22.2056 28.1897 23.0495V32.8812H31.3514ZM11.8103 32.8812H14.972V17.0117H11.8103V32.8812Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4828 14.4008C14.2373 14.4008 14.9747 14.1771 15.602 13.758C16.2293 13.3389 16.7182 12.7431 17.0069 12.0461C17.2956 11.3492 17.3711 10.5822 17.2239 9.8423C17.0767 9.10238 16.7135 8.42272 16.18 7.88927C15.6466 7.35582 14.9669 6.99254 14.227 6.84536C13.4871 6.69818 12.7201 6.77372 12.0231 7.06242C11.3262 7.35112 10.7304 7.84002 10.3113 8.46729C9.89217 9.09456 9.66846 9.83203 9.66846 10.5864C9.66846 11.5981 10.0703 12.5683 10.7857 13.2836C11.501 13.999 12.4712 14.4008 13.4828 14.4008V14.4008Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinShareIcon);
export default __webpack_public_path__ + "static/media/linkedin-share-icon.751cc728dad1e63d9bd9943c7b93e45d.svg";
export { ForwardRef as ReactComponent };